import {TFilter, TList, TResponse} from '@/types';
import {TListItem, TFields, TUpdateParams} from './types';
import {getRefundList} from './mock';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../ws';
import recursiveCheckProvider from '../../../utils/recursiveCheckProvider';

import {
  ENDPOINT_ADMIN_REFUNDS_LIST,
  ENDPOINT_ADMIN_REFUND_UPDATE,
  ENDPOINT_ADMIN_CI_LIST,
  ENDPOINT_ADMIN_CI_ADD,
  ENDPOINT_ADMIN_CI_UPDATE,
  ENDPOINT_ADMIN_CI_DECLINE,
  ENDPOINT_ADMIN_CI_REFUND,
  ENDPOINT_ADMIN_CI_REFUND_STATUS,
  ENDPOINT_ADMIN_CI_ENROLL
} from '../../../constants/api';

export function apiAdminMerchantRefundList(params: TFilter<TFields>): Promise<TList<TListItem>> {
  const url = ENDPOINT_ADMIN_REFUNDS_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 10;

  if (process.env.MOCK) {
    const response = {
      list: getRefundList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminMerchantRefundUpdate(params: TUpdateParams): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_REFUND_UPDATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundList(params: TFilter<TFields>): Promise<TList<TListItem>> {
  const url = ENDPOINT_ADMIN_CI_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 10;

  if (process.env.MOCK) {
    const response = {
      list: getRefundList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundAdd(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_ADD;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundEdit(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_UPDATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundDecline(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_DECLINE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundStart(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_REFUND;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminCustomerRefundStatus(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_REFUND_STATUS;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export const apiAdminCustomerRefundStatusRecursiveCheck = recursiveCheckProvider(
    apiAdminCustomerRefundStatus, 5000,
);

export function apiAdminCustomerRefundEnroll(params): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_CI_ENROLL;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}
